import { Injectable, OnInit, Output, EventEmitter } from '@angular/core';
import { CLEANER_AVAILABILITY } from './mock-users';
import { Http, Response, Headers, URLSearchParams, Jsonp} from '@angular/http';
import { Subject, Subscription } from 'rxjs/Rx';
import {AuthService} from "./auth.service";
import { Router } from "@angular/router";
import * as moment from 'moment';
import { LoaderService } from '../common/loadingBar/loader.service';

@Injectable()
export class CleanerService extends AuthService{
    
    private URLBlockCleaner = "manager/cleaner/:id/block";
    private URLUnBlockCleaner = "manager/cleaner/:id/unblock";
    private URLGetCleanerByID = "manager/cleaner/:id";
    private URLGetCleanerAvailability = "manager/cleaner/:id/availability";
    private URLCleanerComments = "manager/cleaner/:id/comment";
    private URLUpdateCleanerComments = "manager/cleaner/:id/comment/:idComment";
    private ID = ":id";
    private IDCOMMENT = ":idComment";
    constructor(public http: Http, public router: Router, private loaderService: LoaderService ) {
       super(http,router);
    }
        
    public blockCleaner(id: string){
        let URLBlockCleaner = this.URLBlockCleaner.replace(this.ID, id);
        return this.http.put(this.APIURL + URLBlockCleaner, {}, { headers: this.headers })
        .map((res: Response) => res.json()["status"]);
    }

    public unBlockCleaner(id: string){
        let URLUnBlockCleaner = this.URLUnBlockCleaner.replace(this.ID, id);
        return this.http.put(this.APIURL + URLUnBlockCleaner, {}, { headers: this.headers })
        .map((res: Response) => res.json()["status"]);
    }

    public getCleanerById(id: string){
        let URLGetCleanerByID = this.URLGetCleanerByID.replace(this.ID, id);
        return this.http.get(this.APIURL + URLGetCleanerByID, { headers: this.headers })
        .map((res: Response) => res.json()["response"]);
    }

    public updateCleanerData(id: string, data: object) {
        this.loaderService.show();
        let URLGetCleanerByID = this.URLGetCleanerByID.replace(this.ID, id);
        return this.http.put(this.APIURL + URLGetCleanerByID, data, { headers: this.headers })
        .map((res: Response) => {
            this.loaderService.hide();
            return res.json()["status"]
        });
    }

    public getCleanerAvailability(id: string) {
        let URLGetCleanerAvailability = this.URLGetCleanerAvailability.replace(this.ID, id);
        return this.http.get(this.APIURL + URLGetCleanerAvailability, { headers: this.headers })
        .map((res: Response) => this.parseCleanerAvailability(res.json()["response"]));
    }

    public updateCleanerAvailability(id: string, availability: Object) {
        this.loaderService.show();
        let URLGetCleanerAvailability = this.URLGetCleanerAvailability.replace(this.ID, id);
        return this.http.put(this.APIURL + URLGetCleanerAvailability, availability, { headers: this.headers })
        .map((res: Response) => {
            this.loaderService.hide()
            return res.json()["status"]
        });
    }
    
    public getCleanerComments(id: string) {
        let URLGetCleanerComment = this.URLCleanerComments.replace(this.ID, id);
        return this.http.get(this.APIURL + URLGetCleanerComment, { headers: this.headers })
        .map((res: Response) => res.json()["response"])
        .filter(comments => {
            comments.forEach(comment => {
                comment["date"] = moment(comment["upd_date"]).format("DD/MM/YYYY HH:mm");
            });
            return true;
        });
    }

    public createCleanerComment(id: string, data: object) {
        let URLCreateCleanerComment = this.URLCleanerComments.replace(this.ID, id);
        return this.http.post(this.APIURL + URLCreateCleanerComment, data, { headers: this.headers })
        .map((res: Response) => res.json());
    }

    public updateCleanerComment(id: string, idComment: string, data: object) {
        let URLUpdateCleanerComment = this.URLUpdateCleanerComments.replace(this.ID, id).replace(this.IDCOMMENT,idComment);
        return this.http.put(this.APIURL + URLUpdateCleanerComment, data, { headers: this.headers })
        .map((res: Response) => res.json());
    }

    public deleteCleanerComment(id:string, idComment:string) {
        let URLDeleteCleanerComment = this.URLUpdateCleanerComments.replace(this.ID, id).replace(this.IDCOMMENT,idComment);
        return this.http.delete(this.APIURL + URLDeleteCleanerComment, { headers: this.headers })
        .map((res: Response) => res.json());
    }

    private parseCleanerAvailability(availability: Array<object>) {
        var availability_parsed: Array<object> = [];
        var hourIni = moment("7:00","HH:mm");
        var date = moment(hourIni);
        for(var j = 0; j < 15; j++){
            var beginH = moment(date).format("HH:mm");
            var until = moment(date).add(1,"hours").format("HH:mm")
            availability_parsed.push({period: beginH + "-" + until, days: []});
            for(var i= 0; i < availability.length; i++) {
                if(availability[i]["period_ini_time"] == beginH){
                    availability[i]["columnSelected"] = 1;
                    availability_parsed[j]["days"].push(availability[i]);
                }
            }
            date.add(1,"hours");
        }

        return availability_parsed;
    }

    private parseServices(cleanerServices: Array<object>) {
        if(cleanerServices != null){
            cleanerServices.forEach( item => {
                var integer = parseInt(item["n_hours"]);
                var decimals = item["n_hours"] - integer;
                var minutes = (decimals == 0) ? ":00" : ":30";
                item["date"] = moment(item["date"],"YYYY-MM-DD").format("DD/MM/YYYY");
                item["n_hours"] = integer + minutes;
                
            });
        }

        return cleanerServices;
    }
}


// WEBPACK FOOTER //
// ./src/app/injections/cleaner.service.ts